export function kebabCase(str: string = ''): string {
    return str
        .replace(/([^A-Z])([A-Z])/g, '$1-$2') // add - character before every capital letter which previous character isn't capital letter
        .replace(/[\W_]+/g, '-') // replace non word characters and - character with one - character
        .replace(/^-+/, '') // trim - characters at the start of string
        .replace(/-+$/, '') // trim - characters at the end of string
        .toLowerCase(); // make whole string lowercase
}
